import { render, staticRenderFns } from "./AbsencesTableHeader.vue?vue&type=template&id=573ff25e"
import script from "./AbsencesTableHeader.vue?vue&type=script&lang=ts"
export * from "./AbsencesTableHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports